import React, { useState } from 'react';

import { Button } from '@mui/material';
import { sendRestorePasswordLink } from 'config/requests/auth';
import { AuthLayout } from 'layouts/components/AuthLayout/AuthLayout';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'shared/mui/Alert/Alert';
import { Box } from 'shared/mui/Box';
import { TextField } from 'shared/mui/TextField/TextField';

export const RestorePassword = (): JSX.Element => {
  const translate = useTypedTranslate();

  const [reddyNumber, setReddyNumber] = useState('');
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const notify = useNotify();
  const navigate = useNavigate();

  const submit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setShowErrorAlert(false);
    sendRestorePasswordLink(reddyNumber)
      .then((res) => {
        notify(res.data.message, { type: 'success' });
        navigate('login');
      })
      .catch(() => setShowErrorAlert(true));
  };

  return (
    <AuthLayout title={translate('app.restorePassword.setReddyNumber')}>
      <Box sx={{ width: '100%' }}>
        {showErrorAlert && (
          <Alert severity="error" sx={{ marginBottom: '24px' }}>
            {translate('app.restorePassword.notFoundByNumber')}
          </Alert>
        )}
        <form noValidate onSubmit={submit}>
          <TextField
            error={showErrorAlert}
            fullWidth
            id="reddyNumber"
            label={translate('app.login.numberReddy')}
            onChange={(e) => setReddyNumber(e.target.value)}
            size="medium"
            sx={{ marginBottom: '24px !important' }}
            type="text"
            value={reddyNumber}
            variant="outlined"
          />
          <Box sx={{ display: 'flex', gap: '16px' }}>
            <Button fullWidth onClick={() => navigate('/login')} variant="outlined">
              {translate('app.buttons.back')}
            </Button>
            <Button disabled={!reddyNumber.length} fullWidth type="submit" variant="contained">
              {translate('app.buttons.continue')}
            </Button>
          </Box>
        </form>
      </Box>
    </AuthLayout>
  );
};
